import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import {
	type HttpRestoreOfferingMainPhoto,
	httpRestoreOfferingMainPhoto
} from '@/features/service-vetting/http/services-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useRestoreMainPhotoOffering = (
	urlParams: HttpRestoreOfferingMainPhoto['urlParams'],
	options?: UseMutationOptions
) => {
	const queryClient = useQueryClient()
	return useMutation({
		...options,
		mutationFn: () =>
			httpRestoreOfferingMainPhoto({
				urlParams,
				params: {
					response_type: 'small'
				}
			}),
		onError: (error, variables, onMutateResult, context) => {
			errorHandler(error)
			options?.onError?.(error, variables, onMutateResult, context)
		},
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.invalidateQueries({
				queryKey: [QUERY_KEYS.SERVICE_VETTING, urlParams.serviceId]
			})
			queryClient.invalidateQueries({
				queryKey: [
					QUERY_KEYS.SERVICE_GALLERY_IMAGES,
					urlParams.serviceId
				]
			})
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
